export default __webpack_public_path__ + "static/media/souvenirsText.510c4206.png";